// TSM 門禁系統 API

function buildTSMQueryString(params = {}) {
  const query = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") query.append(key, value);
  });
  const qs = query.toString();
  return qs ? `?${qs}` : "";
}

function withoutTSMRetry(options = {}) {
  return { ...(options || {}), retry: 0 };
}

// 二次驗證

/**
 * @function ApiClient#ChallengeTSMReauth
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} scope
 * @param {any} options = {}
 */
export async function ChallengeTSMReauth(cid, scope, options = {}) {
  return await this._post(`/community/${cid}/tsm/reauth/challenge`, { Scope: scope }, withoutTSMRetry(options));
}

/**
 * @function ApiClient#VerifyTSMReauth
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function VerifyTSMReauth(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/reauth/verify`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#RevokeTSMReauth
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function RevokeTSMReauth(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/reauth/revoke`, {}, withoutTSMRetry(options));
}

// 系統設定

/**
 * @function ApiClient#GetTSMConfig
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMConfig(cid, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/config`, options);
  return resp;
}

/**
 * @function ApiClient#UpdateTSMConfig
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMConfig(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/config`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#GetTSMSystemSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMSystemSetting(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/system_setting`, options);
}

/**
 * @function ApiClient#UpdateTSMSystemSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMSystemSetting(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/system_setting`, data, { ...options, retry: 0 });
}

// SyncTSMSystemSetting 從主機同步主機參數設定刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMSystemSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMSystemSetting(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/system_setting/sync`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#BackupTSMDatabase
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function BackupTSMDatabase(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/database/backup`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RecoverTSMDatabase
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function RecoverTSMDatabase(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/database/recovery`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#BeginTSMTaskInputFile
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function BeginTSMTaskInputFile(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/task_input_file/begin`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UploadTSMTaskInputFilePart
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} uploadID
 * @param {any} partNumber
 * @param {any} offset
 * @param {any} size
 * @param {any} sha256
 * @param {any} body
 * @param {any} options = {}
 */
export async function UploadTSMTaskInputFilePart(cid, uploadID, partNumber, offset, size, sha256, body, options = {}) {
  const address = `/community/${cid}/tsm/task_input_file/part`;
  const requestOptions = withoutTSMRetry(options);
  this._requestLog("post", address, { uploadID, partNumber, offset, size }, requestOptions);
  const response = await this._doRequestWithRetry(
    {
      method: "post",
      url: `${this._url}${address}`,
      data: body,
      headers: {
        "Content-Type": "application/octet-stream",
        "X-TSM-Upload-ID": uploadID,
        "X-TSM-Part-Number": String(partNumber),
        "X-TSM-Part-Offset": String(offset),
        "X-TSM-Part-Size": String(size),
        "X-TSM-Part-SHA256": sha256,
        ...(requestOptions.headers || {}),
      },
    },
    { ...requestOptions, isSuccess: requestOptions.isSuccess || ((res) => res?.status === 204) },
  );
  this._responseLog("post", address, response);
  return response;
}

/**
 * @function ApiClient#CompleteTSMTaskInputFile
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CompleteTSMTaskInputFile(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/task_input_file/complete`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DownloadTSMTaskFilePart
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} downloadID
 * @param {any} offset
 * @param {any} size
 * @param {any} options = {}
 */
export async function DownloadTSMTaskFilePart(cid, downloadID, offset, size, options = {}) {
  const query = new URLSearchParams({
    offset: String(offset),
    size: String(size),
  });
  const address = `/community/${cid}/tsm/task_download_file/${encodeURIComponent(downloadID)}/part?${query.toString()}`;
  this._requestLog("get", address, null, options);
  const response = await this._doRequestWithRetry(
    {
      method: "get",
      url: `${this._url}${address}`,
      responseType: "arraybuffer",
    },
    options,
  );
  this._responseLog("get", address, response);
  return response;
}

// 卡機設備

function buildTSMDeviceListQuery({ page, perPage, search, paged, category } = {}) {
  const params = [];
  if (paged) params.push("paged=1");
  if (page) params.push(`p=${page}`);
  if (perPage) params.push(`pp=${perPage}`);
  if (search) params.push(`search=${encodeURIComponent(search)}`);
  if (category) params.push(`category=${encodeURIComponent(category)}`);
  return params.length ? `?${params.join("&")}` : "";
}

/**
 * @function ApiClient#GetTSMDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.paged
 * @param {any} params.category
 * @param {any} options = {}
 */
export async function GetTSMDeviceList(cid, { page, perPage, search, paged, category } = {}, options = {}) {
  const query = buildTSMDeviceListQuery({ page, perPage, search, paged, category });
  const resp = await this._get(`/community/${cid}/tsm/device_list${query}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.paged
 * @param {any} params.category
 * @param {any} options = {}
 */
export async function SyncTSMDeviceList(cid, { page, perPage, search, paged, category } = {}, options = {}) {
  const query = buildTSMDeviceListQuery({ page, perPage, search, paged, category });
  return await this._post(`/community/${cid}/tsm/device_list/sync${query}`, {}, withoutTSMRetry(options));
}

// 設備清單讀取 cloud cache；新增、刪除由門禁設備功能處理，參數派送走專用操作。

// category: network=網路介面器/網路型讀卡機/網路型電梯控制器；controller=一般/四門/電梯/信箱/鐵捲門/車位；空=全部。
/**
 * @function ApiClient#GetTSMControllerList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.category
 * @param {any} options = {}
 */
export async function GetTSMControllerList(cid, { page = 1, perPage = 15, search, category } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  if (category) query.append("category", category);
  const resp = await this._get(`/community/${cid}/tsm/controller_list?${query.toString()}`, options);
  return resp;
}

// SyncTSMControllerList 從主機同步控制器清單並刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMControllerList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.category
 * @param {any} options = {}
 */
export async function SyncTSMControllerList(cid, { page = 1, perPage = 15, search, category } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  if (category) query.append("category", category);
  return await this._post(`/community/${cid}/tsm/controller_list/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

// GetTSMControllerDetail 讀取單一控制器 cm_modify 編輯表單現值，供編輯回填（Mongo-first 直讀快照）。
/**
 * @function ApiClient#GetTSMControllerDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} machineType
 * @param {any} cmID
 * @param {any} options = {}
 */
export async function GetTSMControllerDetail(cid, machineType, cmID, options = {}) {
  return await this._get(`/community/${cid}/tsm/controller_detail/${encodeURIComponent(machineType)}/${encodeURIComponent(cmID)}`, options);
}

// SyncTSMControllerDetail 從主機同步單一控制器明細並刷新 Cloud 快照（編輯視窗「從主機同步」按鈕）。
/**
 * @function ApiClient#SyncTSMControllerDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} machineType
 * @param {any} cmID
 * @param {any} options = {}
 */
export async function SyncTSMControllerDetail(cid, machineType, cmID, options = {}) {
  return await this._post(
    `/community/${cid}/tsm/controller_detail/${encodeURIComponent(machineType)}/${encodeURIComponent(cmID)}/sync`,
    {},
    withoutTSMRetry(options),
  );
}

// GetTSMProgramList 直讀 Cloud 快照取得程式清單（取代原 ExecuteTSMWebOperation 即時 proxy）。
/**
 * @function ApiClient#GetTSMProgramList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.caHW
 * @param {any} params.cmHW
 * @param {any} params.cpHW
 * @param {any} options = {}
 */
export async function GetTSMProgramList(cid, { caHW, cmHW, cpHW } = {}, options = {}) {
  const query = new URLSearchParams();
  if (caHW) query.append("ca_hw", caHW);
  if (cmHW) query.append("cm_hw", cmHW);
  if (cpHW) query.append("cp_hw", cpHW);
  const qs = query.toString();
  return await this._get(`/community/${cid}/tsm/program_list${qs ? "?" + qs : ""}`, options);
}

// SyncTSMProgramList 從主機同步程式清單並刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMProgramList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.caHW
 * @param {any} params.cmHW
 * @param {any} params.cpHW
 * @param {any} options = {}
 */
export async function SyncTSMProgramList(cid, { caHW, cmHW, cpHW } = {}, options = {}) {
  const query = new URLSearchParams();
  if (caHW) query.append("ca_hw", caHW);
  if (cmHW) query.append("cm_hw", cmHW);
  if (cpHW) query.append("cp_hw", cpHW);
  const qs = query.toString();
  return await this._post(`/community/${cid}/tsm/program_list/sync${qs ? "?" + qs : ""}`, {}, withoutTSMRetry(options));
}

function buildTSMProgramFormPath({ pgl, pgt, pgmID } = {}) {
  return [encodeURIComponent(String(pgl ?? "")), encodeURIComponent(String(pgt ?? "")), encodeURIComponent(String(pgmID ?? ""))].join("/");
}

// GetTSMProgramForm 直讀 Cloud 快照取得單一程式編輯表單（取代原 ExecuteTSMWebOperation GET 即時 proxy）。
/**
 * @function ApiClient#GetTSMProgramForm
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.pgl
 * @param {any} params.pgt
 * @param {any} params.pgmID
 * @param {any} options = {}
 */
export async function GetTSMProgramForm(cid, { pgl, pgt, pgmID } = {}, options = {}) {
  return await this._get(`/community/${cid}/tsm/program_form/${buildTSMProgramFormPath({ pgl, pgt, pgmID })}`, options);
}

// SyncTSMProgramForm 從主機同步單一程式表單並刷新 Cloud 快照（編輯視窗「從主機同步」按鈕）。
/**
 * @function ApiClient#SyncTSMProgramForm
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.pgl
 * @param {any} params.pgt
 * @param {any} params.pgmID
 * @param {any} options = {}
 */
export async function SyncTSMProgramForm(cid, { pgl, pgt, pgmID } = {}, options = {}) {
  return await this._post(`/community/${cid}/tsm/program_form/${buildTSMProgramFormPath({ pgl, pgt, pgmID })}/sync`, {}, withoutTSMRetry(options));
}

// SaveTSMProgram 透過具名 API 儲存程式設定，避免前端直接呼叫 TSM generic operation。
/**
 * @function ApiClient#SaveTSMProgram
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SaveTSMProgram(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/program`, data, withoutTSMRetry(options));
}

// DeleteTSMProgram 透過具名 API 刪除程式設定，避免前端直接呼叫 TSM generic operation。
/**
 * @function ApiClient#DeleteTSMProgram
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMProgram(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/program`, { ...withoutTSMRetry(options), data });
}

// ControlTSMProgram 透過具名 API 執行程式控制動作，避免前端直接呼叫 TSM generic operation。
/**
 * @function ApiClient#ControlTSMProgram
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ControlTSMProgram(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/program/control`, data, withoutTSMRetry(options));
}

// SetTSMProgramEnabled 透過具名 API 更新程式啟用狀態，避免前端直接呼叫 TSM generic operation。
/**
 * @function ApiClient#SetTSMProgramEnabled
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SetTSMProgramEnabled(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/program/enabled`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMElevatorSettings
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMElevatorSettings(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/elevator/settings`, options);
}

/**
 * @function ApiClient#SyncTSMElevatorSettings
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMElevatorSettings(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/elevator/settings/sync`, {}, withoutTSMRetry(options));
}

function buildTSMElevatorUserPath(cmID) {
  return encodeURIComponent(String(cmID ?? ""));
}

/**
 * @function ApiClient#GetTSMElevatorUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmID
 * @param {any} options = {}
 */
export async function GetTSMElevatorUsers(cid, cmID, options = {}) {
  return await this._get(`/community/${cid}/tsm/elevator/${buildTSMElevatorUserPath(cmID)}/users`, options);
}

/**
 * @function ApiClient#SyncTSMElevatorUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmID
 * @param {any} options = {}
 */
export async function SyncTSMElevatorUsers(cid, cmID, options = {}) {
  return await this._post(`/community/${cid}/tsm/elevator/${buildTSMElevatorUserPath(cmID)}/users/sync`, {}, withoutTSMRetry(options));
}

// SaveTSMElevatorPublicFloors 透過具名 API 儲存電梯共用樓層。
/**
 * @function ApiClient#SaveTSMElevatorPublicFloors
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SaveTSMElevatorPublicFloors(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/elevator/settings/public_floors`, data, withoutTSMRetry(options));
}

// ResetTSMElevatorPublicFloors 透過具名 API 清除電梯共用樓層。
/**
 * @function ApiClient#ResetTSMElevatorPublicFloors
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ResetTSMElevatorPublicFloors(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/elevator/settings/public_floors`, { ...withoutTSMRetry(options), data });
}

// SaveTSMElevatorAccessFloors 透過具名 API 儲存電梯人員預設樓層。
/**
 * @function ApiClient#SaveTSMElevatorAccessFloors
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SaveTSMElevatorAccessFloors(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/elevator/users/default_floors`, data, withoutTSMRetry(options));
}

// ResetTSMElevatorUsers 透過具名 API 重置電梯全部人員樓層。
/**
 * @function ApiClient#ResetTSMElevatorUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ResetTSMElevatorUsers(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/elevator/users/default_floors`, { ...withoutTSMRetry(options), data });
}

// SaveTSMElevatorUserFloors 透過具名 API 儲存單一人員電梯樓層。
/**
 * @function ApiClient#SaveTSMElevatorUserFloors
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SaveTSMElevatorUserFloors(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/elevator/users/floors`, data, withoutTSMRetry(options));
}

// ResetTSMElevatorUserFloors 透過具名 API 重置單一人員電梯樓層。
/**
 * @function ApiClient#ResetTSMElevatorUserFloors
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ResetTSMElevatorUserFloors(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/elevator/users/floors`, { ...withoutTSMRetry(options), data });
}

// 控制器新增/編輯/刪除走 reauth 二次驗證；apiClient 預設 retry=1 會在非 200
// （如 502 tsm_write_failed）時重打一次有副作用的主機寫入，可能重複派送並蓋掉真實錯誤。
// 故這些單次寫入一律強制 retry:0，只打一次，讓真實結果/錯誤如實回傳。
/**
 * @function ApiClient#CreateTSMNetworkAdapter
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMNetworkAdapter(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/controller/ca`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UpdateTSMNetworkAdapter
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} caID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMNetworkAdapter(cid, caID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/controller/ca/${encodeURIComponent(caID)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMNetworkAdapter
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} caID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMNetworkAdapter(cid, caID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/controller/ca/${encodeURIComponent(caID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#CreateTSMCardMachine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} machineType
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMCardMachine(cid, machineType, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/controller/cm/${encodeURIComponent(machineType)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UpdateTSMCardMachine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} machineType
 * @param {any} cmID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMCardMachine(cid, machineType, cmID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/controller/cm/${encodeURIComponent(machineType)}/${encodeURIComponent(cmID)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMCardMachine
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} machineType
 * @param {any} cmID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMCardMachine(cid, machineType, cmID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/controller/cm/${encodeURIComponent(machineType)}/${encodeURIComponent(cmID)}`, {
    ...options,
    data,
    retry: 0,
  });
}

/**
 * @function ApiClient#GetTSMDoorPointList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMDoorPointList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/doors?${query.toString()}`, options);
  return resp;
}

// SyncTSMDoorPointList 從主機同步門點清單並刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMDoorPointList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMDoorPointList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/doors/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UpdateTSMDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMDevice(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/device`, data, withoutTSMRetry(options));
}

// 從主機同步設備快照與雲端比對，回三類差異報告。
/**
 * @function ApiClient#CheckTSMDeviceConsistency
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function CheckTSMDeviceConsistency(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/devices/consistency`, {}, { ...options, retry: 0 });
}

// 修正一致性差異（目前支援刪除雲端幽靈設備），需高風險權限 + reauth
/**
 * @function ApiClient#ApplyTSMDeviceConsistency
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ApplyTSMDeviceConsistency(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/devices/consistency/apply`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#GetTSMMapSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.groupID
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.assignment
 * @param {any} options = {}
 */
export async function GetTSMMapSetting(cid, { groupID, page = 1, perPage = 30, search, assignment } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (groupID) query.append("groupID", groupID);
  if (search) query.append("search", search);
  if (assignment) query.append("assignment", assignment);
  const resp = await this._get(`/community/${cid}/tsm/maps?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMMapSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.groupID
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.assignment
 * @param {any} options = {}
 */
export async function SyncTSMMapSetting(cid, { groupID, page = 1, perPage = 30, search, assignment } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (groupID) query.append("groupID", groupID);
  if (search) query.append("search", search);
  if (assignment) query.append("assignment", assignment);
  const resp = await this._post(`/community/${cid}/tsm/maps/sync?${query.toString()}`, {}, withoutTSMRetry(options));
  return resp;
}

/**
 * @function ApiClient#GetTSMMapImageUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} path
 */
export function GetTSMMapImageUrl(cid, path) {
  return `${this._url}/community/${cid}/tsm/maps/image?path=${encodeURIComponent(path)}`;
}

/**
 * @function ApiClient#CreateTSMMapArea
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMMapArea(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/maps`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RenameTSMMapArea
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function RenameTSMMapArea(cid, groupID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/maps/${encodeURIComponent(groupID)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UploadTSMMapImage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UploadTSMMapImage(cid, groupID, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/maps/${encodeURIComponent(groupID)}/image`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMMapArea
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMMapArea(cid, groupID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/maps/${encodeURIComponent(groupID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#SetTSMMapDevicePosition
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} deviceID
 * @param {any} data
 * @param {any} options = {}
 */
export async function SetTSMMapDevicePosition(cid, groupID, deviceID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/maps/${encodeURIComponent(groupID)}/devices/${encodeURIComponent(deviceID)}/position`, data, {
    ...options,
    retry: 0,
  });
}

/**
 * @function ApiClient#GetTSMCalibrationTimeSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMCalibrationTimeSetting(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/calibration_time`, options);
}

/**
 * @function ApiClient#UpdateTSMCalibrationTimeSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMCalibrationTimeSetting(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/calibration_time`, data, { ...options, retry: 0 });
}

// SyncTSMCalibrationTimeSetting 從主機同步校時設定刷新 Cloud 快照（同步按鈕，與「傳送到設備」不同）。
/**
 * @function ApiClient#SyncTSMCalibrationTimeSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMCalibrationTimeSetting(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/calibration_time/sync`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#ExecuteTSMDeviceControlAction
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ExecuteTSMDeviceControlAction(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/device/control`, data, { ...options, retry: 0 });
}

// 卡片使用者

/**
 * @function ApiClient#GetTSMCardUserList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMCardUserList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  let url = `/community/${cid}/tsm/card_user_list?p=${page}&pp=${perPage}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const resp = await this._get(url, options);
  return resp;
}

// SyncTSMCardUserList 從主機同步卡片使用者清單刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMCardUserList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMCardUserList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  let url = `/community/${cid}/tsm/card_user_list/sync?p=${page}&pp=${perPage}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  return await this._post(url, {}, withoutTSMRetry(options));
}

// GetTSMCardUserDevices 直讀 Cloud 衍生：卡片使用者依群組關聯應佈署的卡機清單（Mongo-first，不打 TSM 即時查詢）。
/**
 * @function ApiClient#GetTSMCardUserDevices
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} uid
 * @param {any} options = {}
 */
export async function GetTSMCardUserDevices(cid, uid, options = {}) {
  return await this._get(`/community/${cid}/tsm/card_user/devices/${encodeURIComponent(uid)}`, options);
}

/**
 * @function ApiClient#GetTSMCardUserExportUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} format
 */
export function GetTSMCardUserExportUrl(cid, format) {
  return `${this._url}/community/${cid}/tsm/card_user/export/${encodeURIComponent(format)}`;
}

/**
 * @function ApiClient#GetTSMHardwareExportUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetTSMHardwareExportUrl(cid) {
  return `${this._url}/community/${cid}/tsm/device/export/hardware`;
}

/**
 * @function ApiClient#GetTSMMailboxExportUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetTSMMailboxExportUrl(cid) {
  return `${this._url}/community/${cid}/tsm/mailbox/export`;
}

/**
 * @function ApiClient#GetTSMWeeklyScheduleExportUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetTSMWeeklyScheduleExportUrl(cid) {
  return `${this._url}/community/${cid}/tsm/weekly_schedule/export`;
}

/**
 * @function ApiClient#ImportTSMWeeklySchedule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ImportTSMWeeklySchedule(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/weekly_schedule/import`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#GetTSMWeeklyScheduleAssignments
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.cmID
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMWeeklyScheduleAssignments(cid, { cmID, page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (cmID) query.append("cmID", cmID);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/weekly_schedule/user_assignments?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMWeeklyScheduleAssignments
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.cmID
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMWeeklyScheduleAssignments(cid, { cmID, page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (cmID) query.append("cmID", cmID);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/weekly_schedule/user_assignments/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#AssignTSMWeeklyScheduleUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AssignTSMWeeklyScheduleUsers(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/weekly_schedule/user_assignments`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#ClearTSMWeeklyScheduleUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ClearTSMWeeklyScheduleUsers(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/weekly_schedule/user_assignments`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#AddTSMCardUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMCardUser(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/card_user`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UpdateTSMCardUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMCardUser(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/card_user`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMCardUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} uid
 * @param {any} options = {}
 */
export async function DeleteTSMCardUser(cid, uid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/card_user/${uid}`, { ...options, retry: 0 });
}

// 車位群組

/**
 * @function ApiClient#GetTSMParkingGroupList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMParkingGroupList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/parking_groups?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMParkingGroupList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMParkingGroupList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/parking_groups/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#CreateTSMParkingGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMParkingGroup(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/parking_group`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UpdateTSMParkingGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingGroupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMParkingGroup(cid, parkingGroupID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/parking_group/${encodeURIComponent(parkingGroupID)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMParkingGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingGroupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMParkingGroup(cid, parkingGroupID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/parking_group/${encodeURIComponent(parkingGroupID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#GetTSMParkingGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingGroupID
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.assignment
 * @param {any} options = {}
 */
export async function GetTSMParkingGroupMembers(cid, parkingGroupID, { page = 1, perPage = 15, search, assignment } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  if (assignment) query.append("assignment", assignment);
  const resp = await this._get(`/community/${cid}/tsm/parking_group/${encodeURIComponent(parkingGroupID)}/members?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMParkingGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingGroupID
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.assignment
 * @param {any} options = {}
 */
export async function SyncTSMParkingGroupMembers(cid, parkingGroupID, { page = 1, perPage = 15, search, assignment } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  if (assignment) query.append("assignment", assignment);
  return await this._post(
    `/community/${cid}/tsm/parking_group/${encodeURIComponent(parkingGroupID)}/members/sync?${query.toString()}`,
    {},
    withoutTSMRetry(options),
  );
}

/**
 * @function ApiClient#AddTSMParkingGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingGroupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMParkingGroupMembers(cid, parkingGroupID, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/parking_group/${encodeURIComponent(parkingGroupID)}/members`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RemoveTSMParkingGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingGroupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function RemoveTSMParkingGroupMembers(cid, parkingGroupID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/parking_group/${encodeURIComponent(parkingGroupID)}/members`, { ...options, data, retry: 0 });
}

// 門組設定

/**
 * @function ApiClient#GetTSMDoorGroupList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMDoorGroupList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/door_groups?${query.toString()}`, options);
  return resp;
}

// SyncTSMDoorGroupList 從主機同步門組清單並刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMDoorGroupList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMDoorGroupList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._post(`/community/${cid}/tsm/door_groups/sync?${query.toString()}`, {}, withoutTSMRetry(options));
  return resp;
}

/**
 * @function ApiClient#CreateTSMDoorGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMDoorGroup(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/door_group`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UpdateTSMDoorGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMDoorGroup(cid, groupID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/door_group/${encodeURIComponent(groupID)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMDoorGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMDoorGroup(cid, groupID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/door_group/${encodeURIComponent(groupID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#GetTSMDoorGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.assignment
 * @param {any} options = {}
 */
export async function GetTSMDoorGroupMembers(cid, groupID, { page = 1, perPage = 15, search, assignment } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  if (assignment) query.append("assignment", assignment);
  const resp = await this._get(`/community/${cid}/tsm/door_group/${encodeURIComponent(groupID)}/doors?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMDoorGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} params.assignment
 * @param {any} options = {}
 */
export async function SyncTSMDoorGroupMembers(cid, groupID, { page = 1, perPage = 15, search, assignment } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  if (assignment) query.append("assignment", assignment);
  return await this._post(`/community/${cid}/tsm/door_group/${encodeURIComponent(groupID)}/doors/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#AddTSMDoorGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMDoorGroupMembers(cid, groupID, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/door_group/${encodeURIComponent(groupID)}/doors`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RemoveTSMDoorGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function RemoveTSMDoorGroupMembers(cid, groupID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/door_group/${encodeURIComponent(groupID)}/doors`, { ...options, data, retry: 0 });
}

// 人員群組

/**
 * @function ApiClient#GetTSMStaffGroupList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMStaffGroupList(cid, { page, perPage, search } = {}, options = {}) {
  const query = new URLSearchParams();
  if (page) query.set("p", page);
  if (perPage) query.set("pp", perPage);
  if (search) query.set("search", search);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  const resp = await this._get(`/community/${cid}/tsm/staff_group_list${suffix}`, options);
  return resp;
}

/**
 * @function ApiClient#AddTSMStaffGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMStaffGroup(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/staff_group`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UpdateTSMStaffGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMStaffGroup(cid, gid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/staff_group/${gid}`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMStaffGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} options = {}
 */
export async function DeleteTSMStaffGroup(cid, gid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/staff_group/${gid}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#AddTSMStaffGroupMember
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMStaffGroupMember(cid, gid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/staff_group/${gid}/member`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#RemoveTSMStaffGroupMember
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} uid
 * @param {any} options = {}
 */
export async function RemoveTSMStaffGroupMember(cid, gid, uid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/staff_group/${gid}/member/${uid}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RemoveTSMStaffGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} data
 * @param {any} options = {}
 */
export async function RemoveTSMStaffGroupMembers(cid, gid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/staff_group/${gid}/member/remove`, data, withoutTSMRetry(options));
}

// 卡機群組

/**
 * @function ApiClient#GetTSMCardmachineGroupList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMCardmachineGroupList(cid, { page, perPage, search } = {}, options = {}) {
  const query = new URLSearchParams();
  if (page) query.set("p", page);
  if (perPage) query.set("pp", perPage);
  if (search) query.set("search", search);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  const resp = await this._get(`/community/${cid}/tsm/cm_group_list${suffix}`, options);
  return resp;
}

/**
 * @function ApiClient#AddTSMCardmachineGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMCardmachineGroup(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/cm_group`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UpdateTSMCardmachineGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMCardmachineGroup(cid, gid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/cm_group/${gid}`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMCardmachineGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} options = {}
 */
export async function DeleteTSMCardmachineGroup(cid, gid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/cm_group/${gid}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#AddTSMCardmachineGroupMember
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} data
 * @param {any} options = {}
 */
export async function AddTSMCardmachineGroupMember(cid, gid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/cm_group/${gid}/member`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RemoveTSMCardmachineGroupMember
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} mid
 * @param {any} options = {}
 */
export async function RemoveTSMCardmachineGroupMember(cid, gid, mid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/cm_group/${gid}/member/${mid}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RemoveTSMCardmachineGroupMembers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} gid
 * @param {any} data
 * @param {any} options = {}
 */
export async function RemoveTSMCardmachineGroupMembers(cid, gid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/cm_group/${gid}/member/remove`, data, withoutTSMRetry(options));
}

// 群組關聯

/**
 * @function ApiClient#LinkTSMGroups
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function LinkTSMGroups(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/group_link`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UnlinkTSMGroups
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UnlinkTSMGroups(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/group_link`, withoutTSMRetry({ ...options, data }));
}

/**
 * @function ApiClient#SyncTSMGroups
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMGroups(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/sync_groups`, {}, { ...options, retry: 0 });
}

/**
 * @function ApiClient#SyncTSMGroupsFromHost
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMGroupsFromHost(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/groups/sync_from_host`, {}, withoutTSMRetry(options));
}

// 預約/訪客

/**
 * @function ApiClient#GetTSMScheduleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.type
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function GetTSMScheduleList(cid, { type: scheduleType, page = 1, perPage = 15 } = {}, options = {}) {
  let url = `/community/${cid}/tsm/schedule_list?p=${page}&pp=${perPage}`;
  if (scheduleType) url += `&type=${scheduleType}`;
  const resp = await this._get(url, options);
  return resp;
}

/**
 * @function ApiClient#GetTSMReservationList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.fromDate
 * @param {any} params.toDate
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function GetTSMReservationList(cid, { fromDate, toDate, page = 1, perPage = 15 } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);
  const resp = await this._get(`/community/${cid}/tsm/reservation_list?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMReservationList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.fromDate
 * @param {any} params.toDate
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function SyncTSMReservationList(cid, { fromDate, toDate, page = 1, perPage = 15 } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);
  return await this._post(`/community/${cid}/tsm/reservation_list/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMDeliveryScheduleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.fromDate
 * @param {any} params.toDate
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function GetTSMDeliveryScheduleList(cid, { fromDate, toDate, page = 1, perPage = 15 } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);
  const resp = await this._get(`/community/${cid}/tsm/delivery_schedule_list?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMDeliveryScheduleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.fromDate
 * @param {any} params.toDate
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function SyncTSMDeliveryScheduleList(cid, { fromDate, toDate, page = 1, perPage = 15 } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);
  return await this._post(`/community/${cid}/tsm/delivery_schedule_list/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

// ExecuteTSMNSSTSchedule 透過具名 API 執行 NSST 排程立即開始或結束。
/**
 * @function ApiClient#ExecuteTSMNSSTSchedule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ExecuteTSMNSSTSchedule(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/nsst/schedule/execute`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMReservationOptions
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.reservationID
 * @param {any} options = {}
 */
export async function GetTSMReservationOptions(cid, { reservationID } = {}, options = {}) {
  const query = new URLSearchParams();
  if (reservationID) query.append("reservationID", reservationID);
  const qs = query.toString();
  return await this._get(`/community/${cid}/tsm/reservation/options${qs ? `?${qs}` : ""}`, options);
}

/**
 * @function ApiClient#SyncTSMReservationOptions
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.reservationID
 * @param {any} options = {}
 */
export async function SyncTSMReservationOptions(cid, { reservationID } = {}, options = {}) {
  const query = new URLSearchParams();
  if (reservationID) query.append("reservationID", reservationID);
  const qs = query.toString();
  return await this._post(`/community/${cid}/tsm/reservation/options/sync${qs ? `?${qs}` : ""}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#CreateTSMReservation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMReservation(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/reservation`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UpdateTSMReservation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reservationID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMReservation(cid, reservationID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/reservation/${encodeURIComponent(reservationID)}`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMReservation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reservationID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMReservation(cid, reservationID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/reservation/${encodeURIComponent(reservationID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#ExportTSMReservationQRCode
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reservationID
 * @param {any} options = {}
 */
export async function ExportTSMReservationQRCode(cid, reservationID, options = {}) {
  return await this._get(`/community/${cid}/tsm/reservation/${encodeURIComponent(reservationID)}/qrcode/export`, options);
}

/**
 * @function ApiClient#ShowTSMReservationQRCode
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reservationID
 * @param {any} data
 * @param {any} options = {}
 */
export async function ShowTSMReservationQRCode(cid, reservationID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/reservation/${encodeURIComponent(reservationID)}/qrcode/show`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UpdateAllTSMReservationCards
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateAllTSMReservationCards(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/reservation/cards/update`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UpdateTSMReservationCard
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reservationID
 * @param {any} cmID
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMReservationCard(cid, reservationID, cmID, data, options = {}) {
  return await this._put(
    `/community/${cid}/tsm/reservation/${encodeURIComponent(reservationID)}/cards/${encodeURIComponent(cmID)}`,
    data,
    withoutTSMRetry(options),
  );
}

/**
 * @function ApiClient#DeleteTSMReservationCard
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} reservationID
 * @param {any} cmID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMReservationCard(cid, reservationID, cmID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/reservation/${encodeURIComponent(reservationID)}/cards/${encodeURIComponent(cmID)}`, {
    ...options,
    data,
    retry: 0,
  });
}

/**
 * @function ApiClient#CreateTSMSchedule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMSchedule(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/schedule`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMSchedule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} sid
 * @param {any} options = {}
 */
export async function DeleteTSMSchedule(cid, sid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/schedule/${sid}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#CreateTSMGuest
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMGuest(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/guest`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMGuest
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} sid
 * @param {any} options = {}
 */
export async function DeleteTSMGuest(cid, sid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/guest/${sid}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#CreateTSMVisitor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMVisitor(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/visitor`, data, withoutTSMRetry(options));
}

// 信箱

/**
 * @function ApiClient#CreateTSMMailboxUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMMailboxUser(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/user`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMMailboxUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMMailboxUser(cid, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/mailbox/user`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#ImportTSMMailboxList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ImportTSMMailboxList(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/import`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RenameTSMMailboxDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmID
 * @param {any} data
 * @param {any} options = {}
 */
export async function RenameTSMMailboxDevice(cid, cmID, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/device/${encodeURIComponent(cmID)}/name`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMMailboxDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMMailboxDevice(cid, cmID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/mailbox/device/${encodeURIComponent(cmID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#GetTSMMailboxGroups
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMMailboxGroups(cid, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/mailbox/groups`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMMailboxGroups
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMMailboxGroups(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/groups/sync`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#CreateTSMMailboxGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMMailboxGroup(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/groups`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#RenameTSMMailboxGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function RenameTSMMailboxGroup(cid, groupID, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/mailbox/groups/${encodeURIComponent(groupID)}`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMMailboxGroup
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMMailboxGroup(cid, groupID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/mailbox/groups/${encodeURIComponent(groupID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#SetTSMMailboxPosition
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} groupID
 * @param {any} position
 * @param {any} data
 * @param {any} options = {}
 */
export async function SetTSMMailboxPosition(cid, groupID, position, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/mailbox/groups/${encodeURIComponent(groupID)}/positions/${encodeURIComponent(position)}`, data, {
    ...options,
    retry: 0,
  });
}

/**
 * @function ApiClient#RegisterTSMMail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function RegisterTSMMail(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/register`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#UnregisterTSMMail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UnregisterTSMMail(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/unregister`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMLetterNotice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMLetterNotice(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/mailbox/notice`, data, { ...options, retry: 0 });
}

// 週排程

/**
 * @function ApiClient#GetTSMWeeklyScheduleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMWeeklyScheduleList(cid, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/weekly_schedule_list`, options);
  return resp;
}

/**
 * @function ApiClient#UpdateTSMWeeklySchedule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMWeeklySchedule(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/weekly_schedule`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteTSMWeeklySchedule
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmn
 * @param {any} options = {}
 */
export async function DeleteTSMWeeklySchedule(cid, cmn, options = {}) {
  return await this._delete(`/community/${cid}/tsm/weekly_schedule/${cmn}`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#SyncTSMWeeklyScheduleToDb
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmn
 * @param {any} options = {}
 */
export async function SyncTSMWeeklyScheduleToDb(cid, cmn, options = {}) {
  return await this._post(`/community/${cid}/tsm/weekly_schedule/${cmn}/db`, {}, { ...options, retry: 0 });
}

/**
 * @function ApiClient#SyncTSMWeeklyScheduleFromHost
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} cmn
 * @param {any} options = {}
 */
export async function SyncTSMWeeklyScheduleFromHost(cid, cmn, options = {}) {
  return await this._post(`/community/${cid}/tsm/weekly_schedule/${encodeURIComponent(cmn)}/sync_from_host`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMHolidaySetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMHolidaySetting(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/holiday_setting`, options);
}

/**
 * @function ApiClient#UpdateTSMHolidaySetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMHolidaySetting(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/holiday_setting`, data, { ...options, retry: 0 });
}

// SyncTSMHolidaySetting 從主機同步假日設定刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMHolidaySetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMHolidaySetting(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/holiday_setting/sync`, {}, withoutTSMRetry(options));
}

// 事件紀錄

/**
 * @function ApiClient#GetTSMEventList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.typeMode
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.search
 * @param {any} params.status
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function GetTSMEventList(cid, { typeMode, startDate, endDate, search, status, page = 1, perPage = 15 } = {}, options = {}) {
  let url = `/community/${cid}/tsm/event_list?p=${page}&pp=${perPage}`;
  if (typeMode) url += `&typeMode=${typeMode}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (status) url += `&status=${status}`;
  const resp = await this._get(url, options);
  return resp;
}

// GetTSMUnregisteredList 唯讀查詢未授權刷卡紀錄 (對應 TSM information.unregistered)。
// from/to 為可選日期區間 (yyyy-mm-dd)，由日期選擇器產生；backend 直讀 Local 解析後的 typed 列表並分頁。
/**
 * @function ApiClient#GetTSMUnregisteredList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.fromDate
 * @param {any} params.toDate
 * @param {any} params.search
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function GetTSMUnregisteredList(cid, { fromDate, toDate, search, page = 1, perPage = 15 } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/unregistered?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMUnregisteredList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.fromDate
 * @param {any} params.toDate
 * @param {any} params.search
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} options = {}
 */
export async function SyncTSMUnregisteredList(cid, { fromDate, toDate, search, page = 1, perPage = 15 } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/unregistered/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMAlertStats
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMAlertStats(cid, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/alert_stats`, options);
  return resp;
}

/**
 * @function ApiClient#GetTSMAlertUnresolvedList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMAlertUnresolvedList(cid, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/alert_unresolved`, options);
  return resp;
}

// GetTSMAlertLatest 取最新一筆未處理告警 (讀 Mongo TSMEvent), 供 TSMAlertPanel 頂部即時警報橫幅。
// 取代原本 live-poll TSM 主機的 GetTSMRecorderAlarmPrompt; 回 { HasPrompt, Prompt }, Prompt 為 typed 物件或 null。
/**
 * @function ApiClient#GetTSMAlertLatest
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMAlertLatest(cid, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/alert_latest`, options);
  return resp;
}

/**
 * @function ApiClient#GetTSMRecorderRecordList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetTSMRecorderRecordList(cid, params = {}, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/recorder/records${buildTSMQueryString(params)}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMRecorderRecordList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function SyncTSMRecorderRecordList(cid, params = {}, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/records/sync${buildTSMQueryString(params)}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#ExportTSMRecorderRecords
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ExportTSMRecorderRecords(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/export`, data, withoutTSMRetry(options));
}

// BackfillTSMRecorderRecords 把 TSM 主機歷史紀錄 (recorder.list) 同步回填到雲端 TSMEvent。
// 由「從主機同步」按鈕觸發, backend 同步 dispatch 取主機紀錄並逐筆 dedup 寫入 Mongo,
// 之後物業頁讀 Mongo (GetTSMEventList) 即可拿到完整資料, 不必再 live-poll 主機。
// data: { InfoType, FromDate, ToDate }; 回 { Status, Result:{ Total, Imported, Skipped } }。
/**
 * @function ApiClient#BackfillTSMRecorderRecords
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function BackfillTSMRecorderRecords(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/backfill`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMRecorderRange
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMRecorderRange(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/delete_range`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#DeleteAllTSMRecorderRecords
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteAllTSMRecorderRecords(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/delete_all`, data, { ...options, retry: 0 });
}

// 匯出並清除 recorder 紀錄(R3 高風險): backend 先從 Cloud 匯出 zip 建立下載 session, 再清除同區間主機紀錄, 回傳下載資訊
/**
 * @function ApiClient#ExportTSMRecorderAndDelete
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ExportTSMRecorderAndDelete(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/export_and_delete`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#ToggleTSMRecorder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ToggleTSMRecorder(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/toggle`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#GetTSMRecorderAlarmList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetTSMRecorderAlarmList(cid, params = {}, options = {}) {
  const resp = await this._get(`/community/${cid}/tsm/recorder/alarms${buildTSMQueryString(params)}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMRecorderAlarmList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function SyncTSMRecorderAlarmList(cid, params = {}, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/alarms/sync${buildTSMQueryString(params)}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMRecorderAlarmPrompt
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMRecorderAlarmPrompt(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/recorder/alarm_prompt`, options);
}

/**
 * @function ApiClient#SyncTSMRecorderAlarmPrompt
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMRecorderAlarmPrompt(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/alarm_prompt/sync`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#ConfirmTSMRecorderAlarms
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ConfirmTSMRecorderAlarms(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/alarm_confirm`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#GetTSMRecordOutputSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMRecordOutputSetting(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/recorder/output_setting`, options);
}

/**
 * @function ApiClient#SyncTSMRecordOutputSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMRecordOutputSetting(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/recorder/output_setting/sync`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#UpdateTSMRecordOutputSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateTSMRecordOutputSetting(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/recorder/output_setting`, data, withoutTSMRetry(options));
}

// 遠端控制

/**
 * @function ApiClient#TSMOpenDoor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMOpenDoor(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/open_door`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMRecoverAlarm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMRecoverAlarm(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/recover_alarm`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMDownloadCmUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMDownloadCmUser(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/download_cm_user`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMUpdateUserToCm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMUpdateUserToCm(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/update_user_to_cm`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMDeleteUserFromCm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMDeleteUserFromCm(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/delete_user_from_cm`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMStartSystem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function TSMStartSystem(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/start_system`, {}, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMStopSystem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function TSMStopSystem(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/stop_system`, {}, { ...options, retry: 0 });
}

/**
 * @function ApiClient#TSMGetDeviceInfo
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMGetDeviceInfo(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/control/get_device_info`, data, { ...options, retry: 0 });
}

// 批次匯入使用者

/**
 * @function ApiClient#TSMBatchImportUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function TSMBatchImportUsers(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/card_user/batch`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#ImportTSMCardUsers
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ImportTSMCardUsers(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/card_user/import`, data, { ...options, retry: 0 });
}

// 信箱使用者列表

/**
 * @function ApiClient#GetTSMMailboxUserList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMMailboxUserList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = [`p=${page}`, `pp=${perPage}`];
  if (search) query.push(`search=${encodeURIComponent(search)}`);
  const resp = await this._get(`/community/${cid}/tsm/mailbox/user_list?${query.join("&")}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMMailboxUserList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMMailboxUserList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = [`p=${page}`, `pp=${perPage}`];
  if (search) query.push(`search=${encodeURIComponent(search)}`);
  return await this._post(`/community/${cid}/tsm/mailbox/user_list/sync?${query.join("&")}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMMailboxInfo
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.mapPage
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMMailboxInfo(cid, { mapPage = 1, page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("mapPage", mapPage);
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/mailbox/info?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMMailboxInfo
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.mapPage
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMMailboxInfo(cid, { mapPage = 1, page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("mapPage", mapPage);
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/mailbox/info/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMMailboxDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMMailboxDeviceList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/mailbox/devices?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMMailboxDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMMailboxDeviceList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/mailbox/devices/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#GetTSMMailboxOpenDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMMailboxOpenDeviceList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/mailbox/open_devices?${query.toString()}`, options);
  return resp;
}

/**
 * @function ApiClient#SyncTSMMailboxOpenDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMMailboxOpenDeviceList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/mailbox/open_devices/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

// PDF 規格無 update_schedule type_mode (page 5 type_mode 列表只有 Create_schedule / Delete_schedule)
// 編輯/取消排程一律走 Delete_schedule + 重建 (對齊 PDF 「取消預約=刪除預約」語意)
// 原 UpdateTSMSchedule / CancelTSMSchedule 已移除 (backend 從未註冊對應 route 永遠 404 dead code)
// TestTSMConnection 也已移除 (backend 從未實作 /tsm/control/test_connection)
// 連線狀態改看儀表板回應時間顯示，或用既有設備資訊 / 啟動系統按鈕。

// TSM master 帳密管理

/**
 * @function ApiClient#PushTSMAdminCredential
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function PushTSMAdminCredential(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/admin_credential`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#ClearTSMAdminCredential
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function ClearTSMAdminCredential(cid, options = {}) {
  return await this._delete(`/community/${cid}/tsm/admin_credential`, { ...options, retry: 0 });
}

/**
 * @function ApiClient#GetTSMCredentialStatus
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMCredentialStatus(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/admin_credential/status`, options);
}

// TSM 主機帳戶管理

/**
 * @function ApiClient#GetTSMAccountList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetTSMAccountList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  const resp = await this._get(`/community/${cid}/tsm/accounts?${query.toString()}`, options);
  return resp;
}

// SyncTSMAccountList 從主機同步帳戶清單並刷新 Cloud 快照（同步按鈕）。
/**
 * @function ApiClient#SyncTSMAccountList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.page
 * @param {any} params.perPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function SyncTSMAccountList(cid, { page = 1, perPage = 15, search } = {}, options = {}) {
  const query = new URLSearchParams();
  query.append("p", page);
  query.append("pp", perPage);
  if (search) query.append("search", search);
  return await this._post(`/community/${cid}/tsm/accounts/sync?${query.toString()}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#CreateTSMAccount
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateTSMAccount(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/account`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#DeleteTSMAccount
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} accountID
 * @param {any} data
 * @param {any} options = {}
 */
export async function DeleteTSMAccount(cid, accountID, data, options = {}) {
  return await this._delete(`/community/${cid}/tsm/account/${encodeURIComponent(accountID)}`, { ...options, data, retry: 0 });
}

/**
 * @function ApiClient#ChangeTSMAccountPassword
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ChangeTSMAccountPassword(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/account/password`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#ResetTSMAdminPassword
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ResetTSMAdminPassword(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/account/reset_admin_password`, data, { ...options, retry: 0 });
}

/**
 * @function ApiClient#LogoutTSMWebAccount
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function LogoutTSMWebAccount(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/account/logout`, data, { ...options, retry: 0 });
}

// TSM 系統 flag (CommunityCloud 純唯讀; 設定權限在 BuilderCloud / SystemCloud)

/**
 * @function ApiClient#GetTSMSystemFlags
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMSystemFlags(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/system_flags`, options);
}

/**
 * @function ApiClient#GetTSMStatusColor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetTSMStatusColor(cid, options = {}) {
  return await this._get(`/community/${cid}/tsm/status_color`, options);
}

/**
 * @function ApiClient#SyncTSMStatusColor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function SyncTSMStatusColor(cid, options = {}) {
  return await this._post(`/community/${cid}/tsm/status_color/sync`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#SetTSMWebHTTPFlags
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SetTSMWebHTTPFlags(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/system_flags/web_http`, data, withoutTSMRetry(options));
}

/**
 * @function ApiClient#SetTSMBreakGlassFlag
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SetTSMBreakGlassFlag(cid, data, options = {}) {
  return await this._put(`/community/${cid}/tsm/system_flags/break_glass`, data, withoutTSMRetry(options));
}

// TSM 操作稽核

/**
 * @function ApiClient#GetTSMAuditLogList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetTSMAuditLogList(cid, params = {}, options = {}) {
  const query = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") query.append(key, value);
  });
  const qs = query.toString();
  const resp = await this._get(`/community/${cid}/tsm/audit_log${qs ? `?${qs}` : ""}`, options);
  return resp;
}

// TSM 資料傳輸

/**
 * @function ApiClient#GetTSMDeviceTransferDevices
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetTSMDeviceTransferDevices(cid, params = {}, options = {}) {
  return await this._get(`/community/${cid}/tsm/device_transfer/devices${buildTSMQueryString(params)}`, options);
}

/**
 * @function ApiClient#SyncTSMDeviceTransferDevices
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function SyncTSMDeviceTransferDevices(cid, params = {}, options = {}) {
  return await this._post(`/community/${cid}/tsm/device_transfer/devices/sync${buildTSMQueryString(params)}`, {}, withoutTSMRetry(options));
}

/**
 * @function ApiClient#ExecuteTSMDeviceTransfer
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ExecuteTSMDeviceTransfer(cid, data, options = {}) {
  return await this._post(`/community/${cid}/tsm/device_transfer/execute`, data, { ...options, retry: 0 });
}

// 門禁功能盤點與平台化狀態

/**
 * @function ApiClient#GetTSMOperationCatalog
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetTSMOperationCatalog(cid, params = {}, options = {}) {
  const query = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") query.append(key, value);
  });
  const qs = query.toString();
  const resp = await this._get(`/community/${cid}/tsm/operations/catalog${qs ? `?${qs}` : ""}`, options);
  return resp;
}
